import React from 'react';
import { FilterX } from 'lucide-react';
import { showToast } from '../services/toastService';

interface Props {
  onClear: () => void;
  message?: string;
  className?: string;
  title?: string;
  visible?: boolean;
}

const ClearFiltersButton: React.FC<Props> = ({ onClear, message = 'Filtros limpos', className = '', title = 'Limpar filtros', visible = true }) => {
  if (!visible) return null;
  const handle = () => {
    try {
      onClear();
      showToast(message, 'success');
    } catch (e) {
      showToast('Erro ao limpar filtros', 'error');
    }
  };

  return (
    <button onClick={handle} title={title} className={`flex items-center gap-2 px-3 py-2 bg-surface dark:bg-surface-dark border border-line dark:border-line-dark rounded-lg text-sm text-ink-subtitle dark:text-ink-subtitle-dark hover:bg-surface-alt dark:bg-surface-dark-alt ${className}`}>
      <FilterX className="w-4 h-4" />
      <span className="hidden sm:inline">{title}</span>
    </button>
  );
};

export default ClearFiltersButton;
